import { Injectable, signal, WritableSignal } from '@angular/core';
import type { DynamicNotification } from '@drc-eca/eca-components-lib';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  notificationSignal: WritableSignal<DynamicNotification | undefined> = signal(undefined);

  clear() {
    this.notificationSignal.set(undefined);
  }

  showSuccess(message: string) {
    this.notificationSignal.set({
      message,
      type: 'success'
    });
  }

  showWarning(message: string) {
    this.notificationSignal.set({
      message,
      type: 'warning'
    });
  }

  showInfo(message: string) {
    this.notificationSignal.set({
      message,
      type: 'info'
    });
  }

  /** @deprecated Use showSuccess, showWarning, or showInfo instead */
  show(message: string, type: 'positive' | 'negative') {
    const mappedType = type === 'positive' ? 'success' : 'warning';
    this.notificationSignal.set({
      message,
      type: mappedType
    });
  }
}
